export default {
  getInvoicesFilterUrl (state) {
    return state.listInvoicesFilters && Array.isArray(state.listInvoicesFilters)
      ? state.listInvoicesFilters.join(',')
      : [];
  },
};
